export default {
  send(eventCategory, eventAction, eventLabel, eventValue) {
    if (typeof gtag === 'undefined' || pahglobal.googleAnalyticsId === '') {
      console.warn('No Google Analytics');
      return;
    }

    let eventData = {
      'event_category': eventCategory,
      'event_label': eventLabel
    };

    if (eventValue) {
      eventData['value'] = eventValue;
    }

    gtag('event', eventAction, eventData);
  }
}



// WEBPACK FOOTER //
// ./_common/services/ga.service.js